// ======================================================================
// FILE:
// src/modules/expense_management/claims/pages/CreateExpenseClaimPage.jsx
//
// MODULE:
// Expense Management
//
// FEATURE:
// Create Expense Claim
// ======================================================================

import React, {
  useState,
} from "react";

import { useNavigate } from "react-router-dom";

import ExpenseClaimHeader
from "../components/ExpenseClaimHeader";

import ExpenseItemsGrid
from "../components/ExpenseItemsGrid";

import ExpenseSummaryCard
from "../components/ExpenseSummaryCard";

import AttachmentPanel
from "../components/AttachmentPanel";

import CommentPanel
from "../components/CommentPanel";

import WorkflowPanel
from "../components/WorkflowPanel";

import expenseClaimService from "../services/expenseClaimService";
import validateExpenseClaim from "../utils/expenseClaimValidation";

import BusinessReferenceCard from "../components/BusinessReferenceCard";
export default function CreateExpenseClaimPage() {

  const navigate =     useNavigate();

  const [saving, setSaving] =   useState(false);

  // ==========================================================
  // HEADER
  // ==========================================================

  const [header, setHeader] =
    useState({});

  // ==========================================================
  // ITEMS
  // ==========================================================

  const [items, setItems] =
    useState([]);

  // ==========================================================
  // ATTACHMENTS
  // ==========================================================

  const [attachments, setAttachments] =
    useState([]);

  // ==========================================================
  // COMMENTS
  // ==========================================================

  const [comments, setComments] =
    useState([]);

  // ==========================================================
  // WORKFLOW
  // ==========================================================

  const [workflow, setWorkflow] =
    useState([]);

  
  
  // ==========================================================
// BUILD PAYLOAD
// ==========================================================

function buildPayload() {

  return {

    employee_id:
      header.employee_id,

    expense_policy_id:
      header.expense_policy_id,

    currency_id:
      header.currency_id,

    claim_date:
      header.claim_date,

    title:
      header.title,

    purpose:
      header.purpose,

    // ======================================================
    // BUSINESS REFERENCE
    // ======================================================

    expense_source:
      header.expense_source,

    reference_module:
      header.reference_module,

    reference_type:
      header.reference_type,

    reference_id:
      header.reference_id,

    reference_number:
      header.reference_number,

    service_ticket_id:
      header.service_ticket_id,

    service_visit_id:
      header.service_visit_id,

    customer_id:
      header.customer_id,

    installed_product_id:
      header.installed_product_id,
    
      
    items: items.map((item, index) => ({

    line_no:
        index + 1,

    expense_category_id:
        item.expense_category_id,

    expense_type_id:
        item.expense_type_id,

    expense_date:
        item.expense_date,

    vendor_id:
        item.vendor_id || null,

    project_id:
        item.project_id || null,

    cost_center_id:
        item.cost_center_id || null,

    payment_mode_id:
        item.payment_mode_id || null,

    receipt_type_id:
        item.receipt_type_id || null,

    expense_reason_id:
        item.expense_reason_id || null,

    tax_id:
        item.tax_id || null,

    description:
        item.description || null,

    quantity:
        item.quantity ?? 1,

    unit_price:
        item.unit_price ?? Number(item.amount || 0),

    amount:
        Number(item.amount || 0),

    tax_amount:
        Number(item.tax_amount || 0),

    total_amount:
        Number(item.total_amount || 0),

    approved_amount:
        Number(item.approved_amount || 0),

    currency_id:
        item.currency_id || header.currency_id,

    exchange_rate:
        item.exchange_rate || null,

    bill_number:
        item.bill_number || null,

    bill_date:
        item.bill_date || null,

    remarks:
        item.remarks || null,

})),

  };

}
  
    // ==========================================================
  // SAVE DRAFT
  // ==========================================================

 async function handleSaveDraft() {

  try {

    const validation =
      validateExpenseClaim({

          header,
          items,
          attachments,

      });

  if (!validation.isValid) {

      alert(

          validation.errors.join("\n")

      );

      return;

  }
    
    setSaving(true);

    const payload =
      buildPayload();

    await expenseClaimService.createExpenseClaim(
      payload
    );

    alert(
      "Expense Claim saved successfully."
    );

    navigate(
      "/expense-management/claims"
    );

  }

  catch (error) {

    console.error(error);

    alert(

      error?.response?.data?.message ||

      "Unable to save expense claim."

    );

  }

  finally {

    setSaving(false);

  }

}

  // ==========================================================
  // SUBMIT
  // ==========================================================

  async function handleSubmit() {

    await handleSaveDraft();

    }

  // ==========================================================
  // CANCEL
  // ==========================================================

  function handleCancel() {

    navigate(
      "/expense-management/claims"
    );

  }

  // ==========================================================
  // RENDER
  // ==========================================================

  return (

    <div className="container-fluid">

      {/* ====================================================== */}
      {/* HEADER */}
      {/* ====================================================== */}

      <div
        className="card border-0 mb-4"
        style={{

          background:
            "linear-gradient(90deg,#0d6efd,#4f8cff)",

          borderRadius: 12,

          color: "#fff",

        }}
      >

        <div className="card-body">

          <h2 className="mb-1">

            Create Expense Claim

          </h2>

          <div>

            Create a new employee
            expense claim

          </div>

        </div>

      </div>

      {/* ====================================================== */}
      {/* CLAIM HEADER */}
      {/* ====================================================== */}

      <ExpenseClaimHeader

        data={header}

        onChange={setHeader}

      />

      {/* ====================================================== */}
      {/* BUSINESS REFERENCE */}
      {/* ====================================================== */}

      <BusinessReferenceCard

          data={header}

          onChange={setHeader}

      />

      {/* ====================================================== */}
      {/* EXPENSE ITEMS */}
      {/* ====================================================== */}

      <ExpenseItemsGrid

        rows={items}

        onChange={setItems}

      />

      {/* ====================================================== */}
      {/* SUMMARY */}
      {/* ====================================================== */}

      <ExpenseSummaryCard

        items={items}

      />

      {/* ====================================================== */}
      {/* ATTACHMENTS */}
      {/* ====================================================== */}

      <AttachmentPanel

        attachments={attachments}

        onChange={setAttachments}

      />

      {/* ====================================================== */}
      {/* COMMENTS */}
      {/* ====================================================== */}

      <CommentPanel

        comments={comments}

        onChange={setComments}

      />

      {/* ====================================================== */}
      {/* WORKFLOW */}
      {/* ====================================================== */}

      <WorkflowPanel

        rows={workflow}

      />

      {/* ====================================================== */}
      {/* ACTIONS */}
      {/* ====================================================== */}

      <div className="card mt-4">

        <div
          className="
            card-body
            d-flex
            justify-content-end
            gap-2
          "
        >

          <button
            className="
              btn
              btn-outline-secondary
            "
            onClick={
              handleCancel
            }
          >

            Cancel

          </button>

          <button
            className="
              btn
              btn-warning
            "
            onClick={
              handleSaveDraft
            }
          >

            Save Draft

          </button>

          <button
            className="
              btn
              btn-primary
            "
            onClick={
              handleSubmit
            }
          >

            Submit

          </button>

        </div>

      </div>

    </div>

  );

}